export default "__VITE_ASSET__CVTkHC9X__"